/**
 * Iter67d — rezolvarea explicită a reutilizării unui contract existent din formularul manual:
 * `multiple_sales` → BO alege vânzarea vizată (sale_id); `no_sale_for_contract` → confirmă explicit crearea vânzării.
 */
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";

export const LinkResolutionDialog = ({ prompt, onClose, onPickSale, onConfirmCreate }) => {
  const [sel, setSel] = useState("");
  if (!prompt) return null;
  const multi = prompt.code === "multiple_sales";
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="link-resolution-dialog">
        <DialogHeader>
          <DialogTitle>{multi ? "Contractul are mai multe vânzări" : "Contractul nu are nicio vânzare"}</DialogTitle>
          <DialogDescription data-testid="link-resolution-message">{prompt.message}</DialogDescription>
        </DialogHeader>
        {multi ? (
          <div className="space-y-1 text-sm" data-testid="link-resolution-sales">
            {prompt.sales.map((s) => (
              <label key={s.id} className="flex items-center gap-2 rounded border border-slate-200 p-2">
                <input type="radio" name="pick-sale" checked={sel === s.id} onChange={() => setSel(s.id)} data-testid={`link-resolution-sale-${s.id}`} />
                <span className="font-mono text-xs">{s.id.slice(0, 8)}</span>
                <span>{s.agent_name || "agent —"}</span>
                <span className="text-slate-500 text-xs">{s.import_source || ""} · {String(s.created_at || "").slice(0, 10)}</span>
              </label>
            ))}
          </div>
        ) : (
          <p className="text-sm text-slate-700" data-testid="link-resolution-create-note">
            Reutilizarea cere o vânzare existentă. Confirmă explicit crearea unei vânzări pe contractul {String(prompt.contractId || "").slice(0, 8)} (agent/agenție din formular; contractul nu se modifică).
          </p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="link-resolution-cancel">Renunță</Button>
          {multi ? (
            <Button disabled={!sel} onClick={() => onPickSale(sel)} data-testid="link-resolution-pick">Reutilizează vânzarea aleasă</Button>
          ) : (
            <Button onClick={() => onConfirmCreate(prompt.contractId)} data-testid="link-resolution-confirm-create">Confirmă crearea vânzării</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
